import '@phosphor-icons/web/thin/style.css';
import './scss/main.scss';

document.addEventListener('DOMContentLoaded', () => {
  const statusEl = document.querySelector('.status-text');

  if (statusEl) {
    const messages = [
      { text: 'Launch imminent', isWarning: false },
      { text: 'Stand by.', isWarning: true }
    ];

    let currentIdx = 0;

    async function typeWriter(text, el) {
      for (let i = 0; i < text.length; i++) {
        el.textContent += text[i];
        // Random delay simulating natural terminal output stream
        await new Promise(resolve => setTimeout(resolve, 50 + Math.random() * 70));
      }
    }

    async function deleteText(el) {
      while (el.textContent.length > 0) {
        el.textContent = el.textContent.slice(0, -1);
        await new Promise(resolve => setTimeout(resolve, 25));
      }
    }

    async function runLoop() {
      while (true) {
        const current = messages[currentIdx];

        // Toggle warning color class
        if (current.isWarning) {
          statusEl.classList.add('warning');
        } else {
          statusEl.classList.remove('warning');
        }

        // 1. Type message out
        await typeWriter(current.text, statusEl);

        // 2. Pause on complete message
        await new Promise(resolve => setTimeout(resolve, 3500));

        // 3. Backspace delete message
        await deleteText(statusEl);

        // 4. Brief pause before next cycle
        await new Promise(resolve => setTimeout(resolve, 600));

        // Swap indexes
        currentIdx = (currentIdx + 1) % messages.length;
      }
    }

    // Initial delay before start
    setTimeout(runLoop, 1000);
  }

  // Live UTC Clock
  const timeEl = document.querySelector('.live-time');
  if (timeEl) {
    const pad = (num) => String(num).padStart(2, '0');
    const updateTime = () => {
      const now = new Date();
      const year = now.getUTCFullYear();
      const month = pad(now.getUTCMonth() + 1);
      const day = pad(now.getUTCDate());
      const hours = pad(now.getUTCHours());
      const minutes = pad(now.getUTCMinutes());
      const seconds = pad(now.getUTCSeconds());

      timeEl.textContent = `${year}-${month}-${day} ${hours}:${minutes}:${seconds} UTC`;
    };
    updateTime();
    setInterval(updateTime, 1000);
  }
});
